import {
  deleteSearchAlertPublic,
  getSearchAlertForDisplay
} from "./chunk-ZMHFAQNV.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/unsubscribeSearchAlert/unSubscribeSearchAlert.ts
async function getSearchAlertForDisplay2(searchAlertId, params, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getSearchAlertForDisplay");
  try {
    const searchAlert = await getSearchAlertForDisplay(searchAlertId, params, _apiConfig);
    return {
      status: "success",
      data: searchAlert
    };
  } catch (error) {
    apiConfig.onError?.(error);
    throw getErrorResult(error);
  }
}
async function deleteSearchAlertPublic2(searchAlertId, params, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "deleteSearchAlertPublic");
  try {
    const searchAlert = await deleteSearchAlertPublic(searchAlertId, params, _apiConfig);
    return {
      status: "success",
      data: searchAlert
    };
  } catch (error) {
    apiConfig.onError?.(error);
    throw getErrorResult(error);
  }
}

export {
  getSearchAlertForDisplay2 as getSearchAlertForDisplay,
  deleteSearchAlertPublic2 as deleteSearchAlertPublic
};
